import styled from 'styled-components'

export const CatalogItemRatingStarStyled = styled.span`
  position: relative;
  display: block;

  > :nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
  }
`
